@if (!isInit) {
  <div class="app-content">
    Initialisiere Anwendung!
  </div>
}

@if (isInit) {
  <div class="app-content">
    <router-outlet></router-outlet>
  </div>
}

@if (isInit) {
  <app-checkInquirePopup></app-checkInquirePopup>
}
@if (isInit) {
  <app-vorlagenPopup></app-vorlagenPopup>
}
@if (isInit) {
  <app-wiedervorlagenGridPopup></app-wiedervorlagenGridPopup>
}
@if (isInit) {
  <app-wiedervorlagenEditPopup></app-wiedervorlagenEditPopup>
}
<app-docX-multi-preview-popup type="Antrag" #multiRichEditPopup></app-docX-multi-preview-popup>
@if (isInit) {
  <app-loginCodePopup></app-loginCodePopup>
}
@if (isInit) {
  <app-bgb-person-search-popup></app-bgb-person-search-popup>
}
@if (isInit) {
  <app-stapelBearbeitungPopup></app-stapelBearbeitungPopup>
}
@if (isInit) {
  <app-ewo-person-search-popup></app-ewo-person-search-popup>
}
@if (isInit) {
  <app-bgb-stapelberechnung-dialog></app-bgb-stapelberechnung-dialog>
}
@if (isInit) {
  <app-periodenEditPopup></app-periodenEditPopup>
}
@if (isInit) {
  <app-kalenderTerminPopup></app-kalenderTerminPopup>
}
